import { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const AccountManagementCanvasStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const AccountManagementCanvasContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <AccountManagementCanvasStateContext.Provider value={stateHook}>
      {children}
    </AccountManagementCanvasStateContext.Provider>
  );
};

export default AccountManagementCanvasContextProvider;